<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="hypersoft-accessibilty.svg"></div>
    </div>
    <div>
      <h2 langkey="phA11YDialog_Title"></h2>
      <div class="ya-dialog-content">
        <p langkey="phA11YDialog_Description"></p>
      </div>
      <div class="divider"></div>
      <div class="ya-button-group-wrapper">
        <button a11y_Button [class.active]="accessabiltyfontsize" (click)="toggleAccessabiltyFontSize()">
          <div class="accessabilty-icon">
            <div class="inline-icon" inlineSVG="hypersoft-font-size.svg"></div>
          </div>
          <div class="accessabilty-text">
            <span langkey="phA11YDialog_Button_FontSize"></span>
          </div>
        </button>
        <button a11y_Button [class.active]="accessabiltycolors" (click)="toggleAccessabiltyColors()">
          <div class="accessabilty-icon">
            <div class="inline-icon" inlineSVG="hypersoft-a11y-colors.svg"></div>
          </div>
          <div class="accessabilty-text">
            <span langkey="phA11YDialog_Button_ColorContrast"></span>
          </div>
        </button>
        <button a11y_Button [class.active]="accessabiltynoimages" (click)="toggleNoImagesMode()">
          <div class="accessabilty-icon">
            <div class="inline-icon" inlineSVG="hypersoft-a11y-noimg.svg"></div>
          </div>
          <div class="accessabilty-text">
            <span langkey="phA11YDialog_Button_HideImages"></span>
          </div>
        </button>
        <button a11y_Button [class.active]="accessabiltyreducedmotion" (click)="toggleReducedMotionMode()">
          <div class="accessabilty-icon">
            <div class="inline-icon" inlineSVG="hypersoft-a11y-reducedmotion.svg"></div>
          </div>
          <div class="accessabilty-text">
            <span langkey="phA11YDialog_Button_ReducedMotion"></span>
          </div>
        </button>
      </div>
      <div class="ya-button-group-wrapper">
        <button a11y_Button (click)="closeBottomSheet()">
          <div class="accessabilty-text">
            <span langkey="phA11YDialog_Button_Back"></span>
          </div>
        </button>
        <ng-container
          *ngIf="accessabiltyfontsize || accessabiltycolors || accessabiltynoimages || accessabiltyreducedmotion">
          <button a11y_Button (click)="confirmSelection()">
            <div class="accessabilty-text">
              <span langkey="phA11YDialog_Button_Confirm"></span>
            </div>
          </button>
        </ng-container>
        <ng-container
          *ngIf="!accessabiltyfontsize && !accessabiltycolors && !accessabiltynoimages && !accessabiltyreducedmotion && isAccessibilityModeActive">
          <button a11y_Button (click)="resetChanges()" langkey="phA11YDialog_Button_Close"></button>
        </ng-container>
      </div>
      <div class="divider"></div>
      <button a11y_Button (click)="navigateToAccessibilityTerm()">
        <div class="accessabilty-text">
          <span langkey="phA11YDialog_Button_MoreInfo"></span>
        </div>
      </button>
    </div>
  </div>
</div>